"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../../Icons");

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckBox = _styledComponents.default.div.withConfig({
  displayName: "CheckBox",
  componentId: "sc-1tr09wz-0"
})(["display:flex;background-color:", ";height:40px;width:4rem;margin-right:1rem;padding:4px 8px;border-radius:4px;justify-content:center;align-items:center;font-size:1.5rem;color:", ";svg{color:", ";}"], function (p) {
  return (0, _helpers.color)(p.backgroundColor);
}, (0, _helpers.color)('white'), (0, _helpers.color)('white'));

var getStatusColor = function getStatusColor(pass) {
  switch (pass) {
    case true:
      return 'statusOk';

    case false:
      return 'statusCritical';

    default:
      return 'statusUnknown';
  }
};

var getStatusIcon = function getStatusIcon(pass) {
  switch (pass) {
    case true:
      return _react.default.createElement(_Icons.TickIcon, null);

    case false:
      return _react.default.createElement(_Icons.CancelIcon, null);

    default:
      return _react.default.createElement(_react.default.Fragment, null, "N/A");
  }
};

var StatusBox = function StatusBox(_ref) {
  var pass = _ref.pass;
  return _react.default.createElement(CheckBox, {
    backgroundColor: getStatusColor(pass)
  }, getStatusIcon(pass));
};

exports.StatusBox = StatusBox;